import { Button, Form } from 'react-bootstrap'
import { useState } from 'react'
import "./Login.css"
import { Link, Redirect } from 'react-router-dom/cjs/react-router-dom.min'
import LoadingIndicator from '../Indicators/LoadingIndicator'
import ErrorWindow from '../Indicators/ErrorWindow'
import { LOGIN_URL } from '../Api'
import { APP_DIRECTORY } from '../SystemVariables'

const hasValue = (d) => {
    if(d === undefined) return false
    else if(d.trim() === "") return false
    else return true
}

const verify = (username, password) => {
    return hasValue(username) && hasValue(password)
}

export const logIn = async (username, password, setTokens, setUsername) => {
    const payload = {"username": username, "password": password}
    return fetch(LOGIN_URL, {
        method: 'post',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(payload)
    })
    .then(response=>{
        if(response.ok) {
            return response.json()
        } else {
            const err = Error("Something went wrong")
            err.response = response
            throw err
        }
    })
    .then(response=>{
        localStorage.setItem('accessToken', response.access)
        localStorage.setItem('refreshToken', response.refresh)
        localStorage.setItem('username', username)
        setTokens(response)
        setUsername(username)
        return Promise.resolve()
    })
}


const Login = (props) => {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [submitting, setSubmitting] = useState(false)
    const [redirect, setRedirect] = useState(false)
    const [error, setError] = useState(undefined)

    const onUsernameChanged = (event) => {
        setUsername(event.target.value)
    }

    const onPasswordChanged = (event) => {
        setPassword(event.target.value)
    }

    const submit = (event) => {
        event.preventDefault()
        setSubmitting(true)
        logIn(username, password, props.setTokens, props.setUsername)
        .then(()=>{
            setSubmitting(false)
            setRedirect(true)
        })
        .catch(err=>{
            const onUnexpectedError = () => {
                setSubmitting(false)
                setError("Unable to log in. Please check your internet connection, and make sure the username and password is correct.")
            }
            if(err.response !== undefined && err.response.status === 401) {
                err.response.json().then(data=>{
                    setSubmitting(false)
                    setError(`Unable to log in. ${data.detail}.`)
                })
                .catch(()=>{
                    onUnexpectedError()
                })
            } else {
                onUnexpectedError()
            }
        })
    }

    if(props.accessToken && !redirect) {
        setRedirect(true)
    }

    if(submitting) {
        return(<LoadingIndicator message={"Logging in..."}/>)
    } else if(error) {
        return(<ErrorWindow message={error} continue={()=>{setError(undefined)}}/>)
    } else if(redirect) {
        return(<Redirect to={`${APP_DIRECTORY}/`}/>)
    } else {
        return(
            <div className="login">
                <h1>Log in</h1>
                <Form onSubmit={submit}>
                    <Form.Group controlId="username" className="mb-3">
                        <Form.Label>Username</Form.Label>
                        <Form.Control type="text" onChange={onUsernameChanged} value={username}/>
                    </Form.Group>
                    <Form.Group controlId="password" className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" onChange={onPasswordChanged} value={password}/>
                    </Form.Group>
                    <div className="formButtons">
                        <Link to={`${APP_DIRECTORY}/`}><div className="btn btn-danger">Cancel</div></Link>
                        <Button disabled={!verify(username, password)} type="submit">Log in</Button>
                    </div>
                    <div className="needRegister">
                        Don't have an account? <Link to={`${APP_DIRECTORY}/register`}>Register here!</Link>
                    </div>
                </Form>
            </div>)
    }
}

export default Login
